import "antd/dist/antd.css"
import Amplify, { Auth } from "aws-amplify"
import { useEffect } from "react"
import "./App.css"
import config from "./aws-exports"
import Upload from "./components/Upload"

Amplify.configure(config)

function App() {
  return (
    <div
      className="App"
      style={{
        width: 800,
        height: 600,
        padding: 50,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: 'url("./background.png")',
        backgroundSize: "cover"
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          boxShadow: "9px 8px 20px 0 rgba(0,0,0,0.19)",
          borderRadius: 4.5,
          width: 400,
          height: 450,
          padding: 20
        }}
      >
        <img
          src="./meetyou-logo.png"
          style={{ height: 80, width: 80, marginBottom: 10 }}
        />
        <div
          style={{
            fontFamily: "PingFangSC-Regular",
            fontSize: 20,
            color: "#6C6C73",
            textAlign: "center"
          }}
        >
          觅友会员更多资料上传
        </div>
        <Upload />
      </div>
    </div>
  )
}

export default App
